import './index.css';
import { faqs } from './api-data';
import DateCounter from './DateCounter';
import FlashCards from './FlashCard';
import Accordion from './Accordion';

export default function App() {
  return (
    <div className='App'>
      <DateCounter />
      <FlashCards />
      <Accordion data={faqs} />
    </div>
  );
}
